'use client';
import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import AppDownloadModal from '@/components/AppDownloadModal';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

const features = [
{ icon: 'MagnifyingGlassIcon', title: 'Browse Campaigns', desc: 'Discover 280+ active product review campaigns across all categories.' },
{ icon: 'ClipboardDocumentCheckIcon', title: 'Easy Applications', desc: 'Apply to campaigns with one tap. Get notified when you\'re selected.' },
{ icon: 'CameraIcon', title: 'Submit Reviews', desc: 'Write reviews, upload photos, and submit — all from your phone.' },
{ icon: 'BanknotesIcon', title: 'Track Earnings', desc: 'Real-time wallet balance, transaction history, and UPI payout requests.' },
{ icon: 'TrophyIcon', title: 'Level Up', desc: 'Track your reviewer level from Newcomer to Elite with badges and rewards.' },
{ icon: 'UsersIcon', title: 'Refer & Earn', desc: 'Invite friends and earn ₹50 for every successful referral.' }];


const reviews = [
{ name: 'Neha Joshi', city: 'Pune', rating: 5, text: 'Super easy to use. Got my first payout within 5 days!', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1fd3b8400-1784662118528.png" },
{ name: 'Aryan Kapoor', city: 'Delhi', rating: 5, text: 'Best side income app for students. Clean UI, no ads.', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1fc669fcb-1777760127013.png" },
{ name: 'Divya Nair', city: 'Kochi', rating: 4, text: 'Loved the campaign variety. Electronics and beauty are great.', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11eb68cc7-1768659767887.png" }];


export default function AppDownloadPageClient() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Header onDownloadClick={() => setModalOpen(true)} />
      <main className="pt-16 bg-background">
        {/* Hero */}
        <section className="hero-gradient relative overflow-hidden">
          <div className="absolute inset-0 opacity-10 pointer-events-none" style={{ background: 'radial-gradient(ellipse at 70% 50%, #FFFFFF 0%, transparent 60%)' }} />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="space-y-7">
                <div className="flex items-center gap-3">
                  <AppLogo size={52} />
                  <span className="font-heading font-bold text-xl text-white">
                    IndianReview<span className="text-white/80">Club</span>
                  </span>
                </div>
                <h1 className="font-heading font-bold text-white" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', lineHeight: 1.1 }}>
                  Download the App.
                  <br />
                  Start Earning Today.
                </h1>
                <p className="text-white/80 text-lg leading-relaxed">
                  India's most trusted product review app. Apply to campaigns, submit reviews, and receive UPI payouts — all in one place.
                </p>

                <div className="flex flex-col sm:flex-row gap-4">
                  <button
                    onClick={() => setModalOpen(true)}
                    className="flex items-center gap-3 bg-white rounded-xl px-5 py-3.5 hover:bg-primary-container transition-colors">

                    <Icon name="DevicePhoneMobileIcon" size={22} className="text-foreground" />
                    <div className="text-left">
                      <div className="text-[9px] text-foreground/50 uppercase tracking-wide">Get it on</div>
                      <div className="text-sm font-bold font-heading text-foreground">Google Play Store</div>
                    </div>
                  </button>
                  <button
                    onClick={() => setModalOpen(true)}
                    className="flex items-center gap-3 bg-white rounded-xl px-5 py-3.5 hover:bg-primary-container transition-colors">

                    <Icon name="DevicePhoneMobileIcon" size={22} className="text-foreground" />
                    <div className="text-left">
                      <div className="text-[9px] text-foreground/50 uppercase tracking-wide">Download on the</div>
                      <div className="text-sm font-bold font-heading text-foreground">Apple App Store</div>
                    </div>
                  </button>
                </div>

                <div className="flex items-center gap-4 pt-2">
                  <div className="flex -space-x-2">
                    {['https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=40&q=80',
                    'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=40&q=80',
                    'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=40&q=80'].map((src, i) =>
                    <div key={i} className="w-8 h-8 rounded-full border-2 border-white overflow-hidden">
                        <img src={src} alt="Reviewer" className="w-full h-full object-cover" />
                      </div>
                    )}
                  </div>
                  <div className="text-white/80 text-sm">
                    <span className="font-bold text-white">50,000+</span> reviewers already earning
                  </div>
                </div>
              </div>

              {/* QR + Phone mockup */}
              <div className="flex flex-col items-center gap-8">
                <div className="bg-white/95 rounded-3xl p-8 shadow-2xl text-center">
                  <div className="w-40 h-40 bg-muted rounded-2xl flex items-center justify-center mx-auto mb-4 border-2 border-dashed border-border">
                    <div className="text-center">
                      <Icon name="QrCodeIcon" size={60} className="text-foreground/30 mx-auto" />
                      <div className="text-xs text-muted-foreground mt-2">QR Code</div>
                    </div>
                  </div>
                  <div className="font-heading font-semibold text-foreground text-sm mb-1">Scan to Download</div>
                  <div className="text-xs text-muted-foreground">Works on Android & iOS</div>
                  <div className="flex items-center justify-center gap-1 mt-3">
                    {[1, 2, 3, 4, 5].map((s) =>
                    <Icon key={s} name="StarIcon" size={14} variant="solid" className="star-filled" />
                    )}
                    <span className="text-xs text-muted-foreground ml-1">4.8 (12,400+ ratings)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0">
            <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
              <path d="M0 60L1440 60L1440 20C1200 60 960 0 720 20C480 40 240 0 0 20L0 60Z" fill="#F0F2F5" />
            </svg>
          </div>
        </section>

        {/* Features */}
        <section className="section-py bg-background">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-foreground" style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)' }}>
                Everything You Need in One App
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {features.map((f) =>
              <div key={f.title} className="bg-card rounded-2xl border border-border p-6 flex gap-4 card-hover">
                  <div className="w-11 h-11 cta-gradient rounded-xl flex items-center justify-center shrink-0">
                    <Icon name={f.icon as 'MagnifyingGlassIcon'} size={20} className="text-white" />
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-foreground mb-1">{f.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* App Reviews */}
        <section className="section-py bg-surface-variant">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading font-bold text-foreground mb-2" style={{ fontSize: 'clamp(1.25rem, 2.5vw, 1.75rem)' }}>
                What Reviewers Say About the App
              </h2>
              <div className="flex items-center justify-center gap-1">
                {[1, 2, 3, 4, 5].map((s) =>
                <Icon key={s} name="StarIcon" size={18} variant="solid" className="star-filled" />
                )}
                <span className="text-sm text-muted-foreground ml-2">4.8/5 on Play Store</span>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              {reviews.map((r) =>
              <div key={r.name} className="bg-card rounded-2xl border border-border p-6 space-y-4">
                  <div className="flex gap-0.5">
                    {[1, 2, 3, 4, 5].map((s) =>
                  <Icon key={s} name="StarIcon" size={14} variant={s <= r.rating ? 'solid' : 'outline'} className={s <= r.rating ? 'star-filled' : 'text-border'} />
                  )}
                  </div>
                  <p className="text-sm text-muted-foreground italic leading-relaxed">"{r.text}"</p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full overflow-hidden">
                      <img src={r.avatar} alt={`${r.name} review`} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-heading font-semibold text-foreground text-sm">{r.name}</div>
                      <div className="text-xs text-muted-foreground">{r.city}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="section-py bg-background">
          <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center">
            <h2 className="font-heading font-bold text-foreground mb-4" style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)' }}>
              Ready to Start Earning?
            </h2>
            <p className="text-muted-foreground mb-8">
              Download the app and apply to your first campaign today. Free to join, no subscription required.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => setModalOpen(true)}
                className="cta-gradient text-white font-heading font-bold px-8 py-4 rounded-xl hover:opacity-90 transition-opacity">

                Download for Android
              </button>
              <button
                onClick={() => setModalOpen(true)}
                className="border-2 border-secondary text-secondary font-heading font-bold px-8 py-4 rounded-xl hover:bg-secondary-container transition-colors">

                Download for iOS
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <AppDownloadModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>);

}